import { useAppDispatch, useAppSelector } from "hooks";
import React, { useEffect, useState } from "react";
import { nsoFlowFetchData, nsoFlowFetchNsoRequestData } from "../../../../redux/nsoFlow/nsoFlowSlice";
import CommonLoader from "components/CommonLoader";
import { isValidXML, parseXml } from "utils/commonFunctions";

type TomsProps = {
  id: string;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
function Toms({ id }: TomsProps) {
  const nsoSelectorData = useAppSelector((state) => state.nsoFlow.nsoFlow.data[3].data);
  const nsoSelectorLoading = useAppSelector((state) => state.nsoFlow.nsoFlow.loading);
  const [nsoSelector, setNsoSelector] = useState<any>(nsoSelectorData);
  const [requestData, setRequestData] = useState<any>([]);
  const [responseData, setResponseData] = useState<any>([]);
  const nsoError = useAppSelector((state) => state.errorStep.nsoError);
  const isError = nsoError ? nsoError.step >= 4 : false;
  const isAlreadyFetched =
    nsoSelectorData instanceof Array
      ? false
      : "status" in nsoSelectorData
        ? true
        : nsoSelectorData.flow_dtl_id === Number(id);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isError && !isAlreadyFetched) {
      dispatch(nsoFlowFetchData());
      dispatch(nsoFlowFetchNsoRequestData({ id, stepId: 4 }));
    } else {
      setNsoSelector(nsoSelectorData);
    }
  }, [dispatch, id, isAlreadyFetched, isError, nsoSelectorData]);

  useEffect(() => {
    const paraseXmltoJSON = async () => {
      if (nsoSelector.request_xml && (await isValidXML(nsoSelector.request_xml))) {
        const value = await parseXml(nsoSelector.request_xml);
        setRequestData(value === false ? "Error parsing TOMS XML Data !!!" : value.root.vcons?.[0]?.vcon?.[0]?.$);
      }
    };

    const paraseXmltoJSONResponse = async () => {
      if (nsoSelector.response_xml && (await isValidXML(nsoSelector.response_xml))) {
        const value = await parseXml(nsoSelector.response_xml);
        setResponseData(value === false ? "Error parsing TOMS XML Data !!!" : value.root.vcons?.[0]?.vcon?.[0]?.$);
      }
    };

    paraseXmltoJSONResponse();
    paraseXmltoJSON();
  }, [nsoSelector]);

  const vehicleIdentifierData: Array<any> = [
    {
      id: 1,
      name: "Distributor Code",
      value: responseData?.distributor_cd ?? "",
    },
    { id: 2, name: "Model Code", value: requestData?.model ?? "" },
    { id: 3, name: "Model Year", value: requestData?.my ?? "" },
    { id: 4, name: "Plant Code", value: requestData?.plCd ?? "" },
    { id: 5, name: "Port Code", value: requestData?.ptCd ?? "" },
    { id: 6, name: "Region ID", value: requestData?.regId ?? "" },
    { id: 7, name: "Required Date", value: requestData?.reqDt ?? "" },
    { id: 8, name: "VDS", value: responseData?.VDS_ID ?? "" },
    { id: 9, name: "WMI", value: responseData?.WMI ?? "" },
    { id: 10, name: "Japan Model No", value: responseData?.japanmodno ?? "" },
    {
      id: 11,
      name: "Katashiki Name",
      value: responseData?.katashiki_name ?? "",
    },
    { id: 12, name: "SSN", value: responseData?.ssn ?? "" },
    { id: 13, name: "Status", value: responseData?.status ?? "" },
    {
      id: 14,
      name: "Sub Series Code",
      value: responseData?.subseriescode ?? "",
    },
  ];

  const colorData: Array<any> = [
    { id: 1, name: "Exterior", value: requestData?.ec ?? "" },
    { id: 2, name: "Interior", value: requestData?.ic ?? "" },
  ];

  const specifcationData: string = responseData?.spec_200 ?? "";
  const renderData: Array<any> = [
    { id: 1, title: "Vehicle Identifier", data: vehicleIdentifierData },
    { id: 2, title: "Color", data: colorData },
  ];

  if (nsoSelectorLoading) {
    return <CommonLoader active={nsoSelectorLoading} />;
  }

  return (
    <div className="border border-gray-300 rounded-lg shadow-lg gap-4">
      {renderData.map((item) => (
        <div className="w-full bg-gray-100 rounded-lg py-2 m-2" key={item.id}>
          <div className="flex w-full justify-start items-center content-center">
            <span className="font-bold mx-4 text-xl">{item.title}</span>
          </div>
          <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
          <div className="grid grid-cols-3 m-4 gap-4">
            {item.data.map((items: any) => (
              <div className="" key={items.id}>
                <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                  <div className="text-base">{items.name}</div>
                  <div className="text-base">{items.value}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
      <div className="flex w-full justify-start items-center content-center">
        <span className="font-bold mx-4 text-xl">Specifications</span>
      </div>
      <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>

      <div className="grid grid-cols-12 m-2 gap-4 pl-4">
        <div className="text-base col-span-2 align-center items-center flex">Spec 200</div>
        <div className="overflow-x-auto py-2 col-start-3 col-end-12">
          {specifcationData !== "" && (
            <table className="min-w-full">
              <tbody>
                <tr>
                  {specifcationData?.split("").map((item: string, index: number) => (
                    <td key={index} className="p-2 w-2 text-center">
                      {index + 1}
                    </td>
                  ))}
                </tr>
                <tr>
                  {specifcationData?.split("").map((item: string, index: number) => (
                    <td key={index} className="p-2 w-12 text-center">
                      {item}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

export default Toms;
